<template>
  <form @submit.prevent="submit" class="custom-form">
    <user-roles @saveIt="saveIt" />
  </form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import UserRoles from '@/Components/Users/forms/user-roles'
export default {
  name: 'user-organization',
  components: {
    UserRoles,
  },
  props: {
    isAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  emits: ['saveIt'],
  computed: {
    ...mapGetters('users', ['user']),
    ...mapGetters('organizations', ['found']),
    currentOrganization() {
      let _data = null
      if (this.user) {
        _data = this.user.detail.organization
      }
      return _data
    },
  },
  methods: {
    ...mapActions('users', ['setUserData']),
    ...mapActions('organizations', ['findOrganizations']),
    async searchHandler(query) {
      return await this.findOrganizations(query)
    },
    saveIt() {
      this.$emit('saveIt')
    },
  },
}
</script>
<style scoped>
.custom-form {
  min-height: 400px;
}

.custom-current {
  margin-left: 5px;
}
.custom-suggest {
  margin-left: 5px;
  width: auto;
}
</style>
